<template>
	<div>
		<v-container>
			<div v-if="documentId != 0" :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.editingDocument') }}
			</div>
			<div v-else :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.newDocument') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="internalDocument.name"
						:errorBorder="!internalDocumentValidation.name"
						:label="'* ' + $t('fields.name')"
					></InputField>
				</v-col>

				<v-col cols="12" style="text-align: center">
					<Upload
						:readonly="false"
						:showDelete="false"
						v-model="internalDocument.uploaded_file"
						:label="'* ' + $t('fields.file')"
					></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row class="text-center">
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick"> {{ $t('buttons.save') }} </v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InternalDocument from '../../../models/InternalDocument';
import InputField from '../../trinkets/InputField';
import Upload from '../../trinkets/Upload';

export default {
	name: 'Document',
	components: { InputField, Upload },
	props: {
		documentId: [String, Number],
		inEditMode: Boolean,
	},
	emits: ['close', 'reloadData'],
	data() {
		return {
			internalDocumentValidation: new InternalDocument({}, true),
			internalDocument: new InternalDocument({ id: 0, author_id: this.$myStore.state.user.id }),
		};
	},
	computed: {},
	watch: {
		documentId() {
			this.getDocument();
		},
	},
	mounted() {
		this.getDocument();
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getDocument() {
			var vm = this;
			if (this.documentId != 0) {
				this.$APICall(
					'get',
					'internal-documents/' + this.documentId,
					{},
					(data, success) => {
						if (success) {
							vm.internalDocument = data;
						}
					},
					false
				);
			} else {
				this.internalDocument = new InternalDocument({ id: 0, author_id: this.$myStore.state.user.id });
			}
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.internalDocument.name == '') {
				success = false;
				errorMessages += this.$t('alerts.nameMissing') + '<br />';
				this.internalDocumentValidation.name = false;
			} else {
				if (this.internalDocument.name.length > 100) {
					this.internalDocumentValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.internalDocumentValidation.name = true;
				}
			}

			if (!this.internalDocument.uploaded_file.upload_id) {
				success = false;
				errorMessages += this.$t('alerts.fileMissing') + '<br />';
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.documentId) {
					action = 'put';
					addition = '/' + vm.documentId;
				}
				this.$APICall(action, 'internal-documents' + addition, this.internalDocument, (data, success) => {
					if (success) {
						if (vm.documentId == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						this.internalDocument = new InternalDocument({ id: 0, author_id: this.$myStore.state.user.id });
						vm.$emit('reloadData');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
};
</script>
